export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const WALLET_UPDATE = "WALLET_UPDATE";
export const USER_UPDATE = "USER_UPDATE";
